import {GROUPED_BY} from "@constants";

export const normalizeLabel = label => ({
	[GROUPED_BY.COUNTRY]: 'market',
	[GROUPED_BY.RETAILER]: 'retailer',
	[GROUPED_BY.COMPANY]: 'company',
	[GROUPED_BY.BRAND]: 'brand',
	[GROUPED_BY.CATEGORY]: 'category'
})[label] || label